import { defineMessages } from 'react-intl';

export default defineMessages({
  0: {
    id: 'global_all_categories',
    defaultMessage: 'All',
    description: 'products',
  },
  101: {
    id: 'global_indoor_furniture_select',
    defaultMessage: 'Furniture',
    description: 'products',
  },
  102: {
    id: 'global_sport_equipment_select',
    defaultMessage: 'Sports Equipment',
    description: 'products',
  },
  103: {
    id: 'global_electronics_computing_select',
    defaultMessage: 'Electronics & Technology',
    description: 'products',
  },
  104: {
    id: 'global_pets_select',
    defaultMessage: 'Pets',
    description: 'products',
  },
  105: {
    id: 'global_phones_select',
    defaultMessage: 'Phones',
    description: 'products',
  },
  106: {
    id: 'global_musical_instruments_select',
    defaultMessage: 'Musical Instruments',
    description: 'products',
  },
  107: {
    id: 'global_kids_clothing_select',
    defaultMessage: 'Kids',
    description: 'products',
  },
  108: {
    id: 'global_photography_select',
    defaultMessage: 'Photography',
    description: 'products',
  },
  109: {
    id: 'global_art_collectables_select',
    defaultMessage: 'Collectables & Antiques',
    description: 'products',
  },
  110: {
    id: 'global_fashion_select',
    defaultMessage: 'Fashion',
    description: 'products',
  },
  111: {
    id: 'global_health_beauty_select',
    defaultMessage: 'Health and Beauty',
    description: 'products',
  },
  112: {
    id: 'global_car_parts_and_accessories',
    defaultMessage: 'Parts and Accessories',
    description: 'products',
  },
});



// WEBPACK FOOTER //
// ./app/common/forms/messages.products.js